(function (){
    'use strict';

    angular
        .module('app')
        .directive('passwordValidateAdmin', passwordValidateAdmin);

    function passwordValidateAdmin() {
       return {
           restrict:'A',
           require:'ngModel',
           scope:{
               cod: '='
           },
           link:link,

       };

        function link(scope, element, attrs, ctrl) {
            var firstPassword = '#' + attrs.pwCheck;
            elem.add(firstPassword).on('keyup', function () {
                scope.$apply(function () {
                    var v = elem.val()===$(firstPassword).val();
                    ctrl.$setValidity('pwmatch', v);
                });
            });


        }

    }
})();